export const LANG = (navigator.language || 'en').split('-')[0];


export const TEMPLATE_LABELS = {
    logIn: 'Log in',
    signUp: 'Sign up',
    logInOrSignUp: 'Log in or sign up',
    becomeAHost: 'Become a host',
    moreActions: 'More actions',
    moreOptions: 'More options',
    saveAndExit: 'Save and exit',
    saveAndContinue: 'Save and continue',
    today: 'Today',
    nextMonth: 'Next Month',
    previousMonth: 'Previous Month',
    pickAYear: 'Pick a Year',
    street: 'Street',
    city: 'City',
    zipCode: 'Zip code',
    country: 'Country',
    county: 'County',
    state: 'State',
    address: 'Address',
    basicInfo: 'Basic Info',
    guestAmount: 'Guest Amount',
    pricing: 'Pricing',
    uploadPhotos: 'Upload Photos',
    propertyName: 'Property Name',
    goBack: 'Go Back',
    uploadFile: 'Upload file',
    or: 'or',
    dropFile: 'drop file',
    remove: 'Remove',
    delete: 'Delete',
    selectAnOption: 'Select an Option',
    save: 'Save',
    cancel: 'Cancel',
};

export const LABELS = {
    en: { 
        logIn: 'Log in',
        signUp: 'Sign up',
        save: 'Save', 
        guests: 'Guests',
        date: 'Date',
        destination: 'Destination',
        'become a host': 'Become A Host',
        'help center': 'Help Center',
        'account details': 'Account Details',
        'activity': 'Activity',
        'messages': 'Messages',
        'my listings': 'My Listings',
        'address': 'Address',
        'basic info': 'Basic Info',
        'guest amount': 'Guest Amount',
        'pricing': 'Pricing',
        'upload photos': 'Upload Photos', 
        'property name': 'Property name',
        'log out': 'Log out',
        'search': 'Search',
        'county': 'County',
        'country': 'Country',
        'zip code': 'Zip code',
        'state': 'State',
        'city': 'City',
        'street': 'Street',
        'log in or sign up': 'Log in or sign up',
        'nearby events': 'Nearby events',
        'all events': 'All events',
        'more actions': 'More actions',
        'more options': 'More options',
        'save and exit': 'Save and exit',
        'save and continue': 'Save and continue',
        'previous month': 'próximo mes',
        'next month': 'previo mes',
        'january': 'January',
        'february': 'February',
        'march': 'March',
        'april': 'April',
        'may': 'May',
        'june': 'June',
        'july': 'July',
        'august': 'August',
        'september': 'September',
        'october': 'October',
        'november': 'November',
        'december': 'December',
        'today': 'Today',
        'pick a year': 'Pick a Year',
        'step 1: address': 'Step 1: Address',
        'step 2: basic info': 'Step 2: Basic info',
        'step 3: guests': 'Step 3: Guests',
        'step 4: pricing': 'Step 4: Pricing',
        'step 5: upload photos': 'Step 5: Upload photos',
        'step 6: listing name': 'Step 6: Listing name',
        'go back': 'Go Back',
        'indoor': 'Indoor',
        'outdoor': 'Outdoor',
        chlorine: 'Chlorine',
        saltwater: 'Saltwater',
        'restroom in main residence': 'Restroom in main residence',
        'detached restroom': 'Detached restroom',
        'portable restroom': 'Portable restroom',
        'no restroom': 'No restroom',
        'upload file': 'Upload file',
        or: 'or',
        'drop file': 'drop file',
        remove: 'Remove',
        delete: 'Delete',
        'profile photo': 'Profile Photo',
        name: 'Name',
        gender: 'Gender',
        email: 'Email',
        phone: 'Phone',
        birthday: 'Birthday',
        language: 'Language',
        'select an option': 'Select an option...',
        'select an option...': 'Select an option...',
        cancel: 'Cancel',

    },
    es: { 
        logIn: 'Iniciar sessión',
        signUp: 'Registrarte',
        save: 'Guardar',
        guests: 'Huéspedes',
        date: 'Fecha',
        destination: 'Destino',
        'become a host': 'Conviértete en anfitrión',
        'help center': 'Centro de ayuda',
        'account details': 'Detalles de la cuenta',
        'activity': 'Actividad',
        'messages': 'Mensajes',
        'my listings': 'Mis anuncios',
        'address': 'Dirección',
        'basic info': 'Información básica',
        'guest amount': 'Número de huéspedes',
        'pricing': 'Precio', // or 'Precios' depending on context
        'upload photos': 'Subir fotos',
        'property name': 'Nombre de la propiedad',
        'log out': 'Cerrar sesión', // typo fixed + accent
        'search': 'Buscar',
        'county': 'Condado', // ⚠️ see note below
        'country': 'País',   // missing accent
        'zip code': 'Código postal',
        'state': 'Estado',
        'city': 'Ciudad',
        'street': 'Calle',
        'log in or sign up': 'Iniciar sessión o registrarte',
        'nearby events': 'Eventos cercanos',
        'all events': 'Todos los eventos',
        'more actions': 'Más acciónes',
        'more options': 'Más opciónes',
        'save and exit': 'Guardar y salir',
        'save and continue': 'Guardar y continuar',
        'january': 'Enero',
        'february': 'Febrero',
        'march': 'Marzo',
        'april': 'Abril',
        'may': 'Mayo',
        'june': 'Junio',
        'july': 'Julio',
        'august': 'Agosto',
        'september': 'Septiembre',
        'october': 'Octubre',
        'november': 'Noviembre',
        'december': 'Diciembre',
        'today': 'Hoy',
        'listing name': 'Nombre de Propiedad',
        'pick a year': 'Seleccionar año',
        'step 1: address': 'Paso 1: Dirección',
        'step 2: basic info': 'Paso 2: Información básica',
        'step 3: guests': 'Paso 3: Huéspedes',
        'step 4: pricing': 'Paso 4: Precio',
        'step 5: upload photos': 'Paso 5: Subir fotos',
        'step 6: listing name': 'Paso 6: Nombre de Propiedad',
        'go back': 'Atrás',
        'indoor': 'Interior',
        'outdoor': 'Aire Libre',
        chlorine: 'Chlorína',
        saltwater: 'Agua Salinado',
        'restroom in main residence': 'Baño en la residencia principal',
        'detached restroom': 'Baño en el exterior',
        'portable restroom': 'Baño portatíl',
        'no restroom': 'Sin baño',
        'upload file': 'Subir archivo',
        or: 'o',
        'drop file': 'arrastrar archivo',
        remove: 'Quitar',
        delete: 'Borrar',
        'attachment': 'Conjunto',
        'profile photo': 'Foto de Perfil',
        name: 'Nombre',
        gender: 'Género',
        email: 'Correo Electrónico',
        phone: 'Teléfono',
        birthday: 'Fecha de Nacimiento',
        language: 'Idioma',
        'select an option': 'Seleccionar una opción...',
        'select an option...': 'Seleccionar una opción...',
        male: 'Hombre',
        female: 'Mujer',
        'non-binary': 'Sin classificación',
        'prefer not to say': 'Prefiero no decir',
        'first name': 'Nombre',
        'last name': 'Apellido',
        cancel: 'Cancelar',
    }
};


const HOST_ONBOARD_LABELS = {
    en: {
        'Full Pool': 'Full Pool',
        'Framed Pool': 'Framed Pool',
        'Hot Tub': 'Hot Tub',
        'Cold Plunge': 'Cold Plunge',
        address__label: 'Property Address',
        basicDetails: 'Add Basic Details',
        environment_type__label: 'What kind of pool?',
        water_system__label: 'What kind of water system?',
        restroom_type__label: 'Is there a restroom?',
        max_guests__title: 'Set Guest Amount',
        max_guests__subtitle: 'What is the maximum number of guests?',
        max_guests__detail1: 'Select a maximum of 250 and a minimum of 1 guests.',
        max_guests__detail2: 'To get the most out of your listing we recommend allowing least 20 guests.',
        hostPoolPrice__title: 'Set pool pricing',
        hostPoolPrice__subtitle: 'How much will it cost per hour of booking?',
        listing_photo__title: 'Add Pool Photos',
        listing_photo__subtitle: 'Show your pool from its best angles to attract more guests.',
        property_name__title: 'Property Name',
        property_name__subtitle: 'Give a name to your listing.  This will appear along side you primary photo on the listings page.',
        property_name__placeholder: 'Seaside Oasis w/ Private Deck'
    },
    es: {
        'Full Pool': 'Piscina completa',
        'Framed Pool': 'Piscina estructural',
        'Hot Tub': 'Jacuzzi',
        'Cold Plunge': 'Baño frío',
        address__label: 'Dirección de la propiedad',
        basicDetails: 'Agregar detalles básicos',
        environment_type__label: '¿Qué tipo de piscina es?',
        water_system__label: '¿Qué tipo de sistema de agua tiene?',
        restroom_type__label: '¿Hay baño disponible?',
        max_guests__title: 'Establecer cantidad de huéspedes',
        max_guests__subtitle: '¿Cuál es el número máximo de huéspedes?',
        max_guests__detail1: 'Selecciona un máximo de 250 y un mínimo de 1 huésped.',
        max_guests__detail2: 'Para aprovechar mejor tu anuncio, recomendamos permitir al menos 20 huéspedes.',
        hostPoolPrice__title: 'Establecer precio de la piscina',
        hostPoolPrice__subtitle: '¿Cuánto costará por hora de reserva?',
        listing_photo__title: 'Agregar fotos de la piscina',
        listing_photo__subtitle: 'Muestra tu piscina desde sus mejores ángulos para atraer más huéspedes.',
        property_name__title: 'Nombre de la propiedad',
        property_name__subtitle: 'Dale un nombre a tu anuncio. Aparecerá junto a la foto principal en la página de listados.',
        property_name__placeholder: 'Oasis frente al mar con terraza privada'
    }
}

export function getHostOnBoardLabels() {
    return HOST_ONBOARD_LABELS[LANG ?? 'en'];
}


export function getLabels() {
    return LABELS[LANG] || LABELS.en;
}

export function getLabelsByLanguage(label) {
    const labelLower = label?.toLowerCase();
    return LABELS[LANG]?.[labelLower] ?? label;
}


export function mapTemplateLabels(templateLabels) {
    if (!templateLabels) return {};

    if (Array.isArray(templateLabels) || typeof templateLabels !== 'object') {
        throw new Error('mapTemplateLabels(): templateLabels argument must be of type object.');
    }

    return Object.fromEntries(
        Object.entries(templateLabels).map(([key, label]) => 
            [key, getLabelsByLanguage(label)]
        )
    );
    
}